// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingPageB_container__dmB2z","form-input":"OnBoardingPageB_form-input__tw9YD","prefix":"OnBoardingPageB_prefix__8EERO"};